import {useSelector} from "react-redux";

import {IRPStore} from "../app/rp_reducer";
import {useGetUserProfileQuery} from "../user/api/get_user_profile";
import {checkHasCompleteProfile} from "../user/utils/check_has_complete_profile";
import {checkHasVerifiedPhone} from "../user/utils/check_has_verified_phone";

export const useShouldHidePrices = () => {
    const {data: userInfo} = useGetUserProfileQuery();
    const isPricesUnlocked = useSelector((state: IRPStore) => state.pricesUnlocked.isUnlocked);

    const hasCompleteProfile = checkHasCompleteProfile(userInfo);
    const hasPhoneVerified = checkHasVerifiedPhone(userInfo);
    const isUserLoggedIn = Boolean(userInfo);

    // Prices should be shown if:
    // 1. User has complete profile (authenticated with name and phone)
    // 2. OR prices have been manually unlocked (e.g., after sending a lead)
    return {
        shouldHidePrices: (!hasCompleteProfile || !hasPhoneVerified) && !isPricesUnlocked,
        hasCompleteProfile,
        hasPhoneVerified: hasPhoneVerified,
        isUserLoggedIn
    };
};
import {useSelector} from "react-redux";

import {IRPStore} from "../app/rp_reducer";
import {useGetUserProfileQuery} from "../user/api/get_user_profile";
import {checkHasCompleteProfile} from "../user/utils/check_has_complete_profile";
import {checkHasVerifiedPhone} from "../user/utils/check_has_verified_phone";

export const useShouldHidePrices = () => {
    const {data: userInfo} = useGetUserProfileQuery();
    const isPricesUnlocked = useSelector((state: IRPStore) => state.pricesUnlocked.isUnlocked);

    const hasCompleteProfile = checkHasCompleteProfile(userInfo);
    const hasPhoneVerified = checkHasVerifiedPhone(userInfo);
    const isUserLoggedIn = Boolean(userInfo);

    // Prices should be shown if:
    // 1. User has complete profile (authenticated with name and phone)
    // 2. OR prices have been manually unlocked (e.g., after sending a lead)
    return {
        shouldHidePrices: (!hasCompleteProfile || !hasPhoneVerified) && !isPricesUnlocked,
        hasCompleteProfile,
        hasPhoneVerified: hasPhoneVerified,
        isUserLoggedIn
    };
};
